import jsonpointer from "jsonpointer";

const convertErrors = (errors) => {
    const res = {
        message: null,
        fields: {}
    };

    if (errors && errors.message) {
        res.message = errors.message;
    }

    if (errors && errors.data && errors.data.errors) {
        errors.data.errors.forEach((el) => {
            const path = '/' + el.path;
            const currentErrors = jsonpointer.get(res.fields, path) || [];
            jsonpointer.set(res.fields, path, [...currentErrors, el.error]);
        });
    }

    return res;
};

export default convertErrors;